import React, { useState } from "react";
import { EnrichedSwarovskiProductFrontendProductReview, SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { FONTS, fontSize } from "../../styles/fonts";
import { CommentTranslation } from "./CommentTranslation";
import { getCommentTranslation } from "./getCommentTranslation";
import { ReviewTranslations } from "./reviewTranslations";
import { PDPReviewCommentTranslationBar } from "./PDPReviewCommentTranslationBar";
import { css } from "@emotion/react";
import { usePageLocaleContext } from "../../global/page-context";

export const PDPReviewComment: React.FC<{
  comment: EnrichedSwarovskiProductFrontendProductReview["comment"];
  t: ReviewTranslations;
}> = ({ comment, t }) => {
  const { locale } = usePageLocaleContext();
  const state = getCommentTranslation(comment, locale);
  const [showOriginal, showTranslated] = useState(false);

  const onClick = () => {
    showTranslated(s => !s);
  };

  function isUsingCommentTranslation(ct: CommentTranslation) {
    switch (ct.tag) {
      case "no-translated-comment-available": {
        return null;
      }
      case "original-comment-language-matches-current-language": {
        return null;
      }
      case "translated-comment-into-current-language": {
        return ct.languageIsoCode;
      }
      case "translated-comment-into-english": {
        return ct.languageIsoCode;
      }
      default: {
        const _: never = ct;

        return _;
      }
    }
  }

  const isUsingTranslatedComment = isUsingCommentTranslation(state);

  return (
    <div>
      <p
        css={[
          FONTS.SwarovskiFutura300,
          fontSize.x2,
          css`
            line-height: 1.4;
          `,
        ]}
        className="u-m-0"
      >
        {showOriginal ? comment.original : state.comment}
      </p>

      <PDPReviewCommentTranslationBar
        commentLanguageIsoCode={comment.languageIsoCode}
        isUsingTranslatedComment={isUsingTranslatedComment}
        onClick={onClick}
        showOriginal={showOriginal}
        t={t}
        locale={locale}
      />
    </div>
  );
};
